import React from 'react';

function InternshipApply() {
  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-base font-semibold text-[#0049ac] tracking-wide uppercase">Application Form</h2>
          <p className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight">
            Join Our Team
          </p>
        </div>
        
        <div className="bg-white rounded-lg overflow-hidden">
          <iframe 
            src="https://api.leadconnectorhq.com/widget/form/i9jNoVIolsgUW5NWa8zX" 
            style={{
              width: '100%',
              height: '3893px',
              border: 'none',
              borderRadius: '3px'
            }}
            id="inline-i9jNoVIolsgUW5NWa8zX" 
            data-layout="{'id':'INLINE'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="Intern Form"
            data-height="3893"
            data-layout-iframe-id="inline-i9jNoVIolsgUW5NWa8zX"
            data-form-id="i9jNoVIolsgUW5NWa8zX"
            title="Intern Form"
          />
          <script src="https://link.msgsndr.com/js/form_embed.js" async></script>
        </div>
      </div>
    </div>
  );
}

export default InternshipApply;